import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataServiceConfig,
    EntityCollectionService,
    EntityServices,
    HttpUrlGenerator,
    QueryParams
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Guid } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { IndirectRateAdjust } from './indirect-rate-adjust.model';
import { entityName as jobTimerEntityName, JobTimerModel } from '../job-timer';
export const entityName = 'IndirectRateAdjust';
@Injectable({ providedIn: 'root' })
export class IndirectRateAdjustDataService extends EfaactDataService<IndirectRateAdjust> {
    private jobTimerDataService: EntityCollectionService<JobTimerModel>;
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store,
        private entityServices: EntityServices
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
        this.jobTimerDataService =
            entityServices.getEntityCollectionService<JobTimerModel>(
                jobTimerEntityName
            );
    }
    mapItems(item: IndirectRateAdjust): IndirectRateAdjust {
        return { ...item, id: Guid.newGuid() };
    }

    getWithQuery(
        params: string | QueryParams
    ): Observable<IndirectRateAdjust[]> {       
        return super.getWithQuery(params);
    }
    getAll(): Observable<IndirectRateAdjust[]> {
        return super.getAll();
    }

    mapGetResponse(resp) {
        this.log.verbose({
            type: `${this.entityName}DataService(IndirectRateAdjustDataService):mapResponse:resp`,
            resp
        });
        const result = JSON.parse(resp) as IndirectRateAdjust[];
        this.log.verbose({
            type: `${this.entityName}DataService(IndirectRateAdjustDataService):mapResponse:result`,
            result
        });
        setTimeout(() => {
            this.jobTimerDataService.getWithQuery({
                Jobdesc: sessionStorage.getItem('jobTimerName')
            });
        }, 0);
        if (Array.isArray(result)) {
            return result;
        } else {
            return [] as IndirectRateAdjust[];
        }
    }
}
